import { TextareaAutosize, TextField,Button } from '@material-ui/core';
import React, { useState ,useEffect} from 'react';
import {  Col, Container, Row ,Image} from 'react-bootstrap';
import './Contact.css'
import OurClient from './OurClient'
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import FooterLinks from './FooterLink';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FiberManualRecord, FilterCenterFocusOutlined } from '@material-ui/icons';

function Contact(){

  const [userFname,setUserFname]=useState(null )
  const [userLname,setUserLname]=useState(null)

  const   myVar =()=>{  
    setTimeout(window.location.reload(false),1200);}


const submitForm=(e)=>{
  e.preventDefault();
  console.log(userFname,userLname)
  if(userFname  && userLname ){
    console.log(userFname,userLname)
    toast.success("Form Submitted")
    myVar()
  }
  else{
    
    alert("plz check")
  }
 
}

const getValueFname=(val)=>{ 
  // console.log("helo",val.target.value)
  setUserFname(val.target.value)
}
const getValueLname=(val1)=>{
  // console.log("helo",val.target.value)
  setUserLname(val1.target.value)
}



// function userChange(e){
//   console.log("hello",e.target.value)
// }


  
  function  NewsLetters() {
    alert("SORRY :  This Service Is Unavailable At This Time")
  }
const check=()=>toast.success("hello")

  
    return(
      <>
        <div className="ContactMain">
      <Container>
     
   <span>.</span>
<h1 className="ContactMainHeading"style ={{marginTop:"50px"}} >Contact Us </h1>
<h5 className="ContactMainHeading">Get In Touch</h5>

<Row style ={{marginTop:"50px"}}  >
  <Col md={6}>
    <h1>{userLname}</h1>
    <h4 className="ContactMainHeadingColor">Rapid Movers & Packers Office Address:</h4>
    <h4 className="ContactMainHeadingColorH4">31-FF Center Point Plaza, Gulberg III, Lahore, 54700</h4>
    <h4 className="ContactMainHeadingColorH4">Mobile: <span className="ContactMainHeadingColor"> 0313 140 3381</span></h4>
    <h4 className="ContactMainHeadingColorH4">WhatsApp: <span className="ContactMainHeadingColor"> 0313 140 3381</span></h4>
    <h4 className="ContactMainHeadingColorH4">Email: <span className="ContactMainHeadingColor"> Info@rapidmovers.pk</span></h4>
    <h4 className="ContactMainHeadingColorH4">Main Office:  <span className="ContactMainHeadingColor"> Office no 57 defense shopping Mall main boluverd DHA Lahore Lahore, 54810</span></h4>
    <h4 className="ContactMainHeadingColorH4">Sub Office -01: <span className="ContactMainHeadingColor"> 31/2 center point plaza Lahore, 54000</span></h4>
    <h4 className="ContactMainHeadingColorH4">Sub Office -02:<span className="ContactMainHeadingColor"> House no 91 street no 3 Block A Phase 1 agrics town Raiwind Road Lahore Lahore, 54784</span></h4>
  </Col>
  <Col md={6}>
    <h4 className="ContactMainHeadingColorH4" style ={{marginBottom:"30px"}}>Get A Quote</h4>
    <form onSubmit={submitForm}>
  <Row>
    
    <Col md={6}>  <TextField id="filled-basic" label="First Name" variant="filled" className="ContactForm bg-light" style={{marginBottom:'15px'}} onChange={getValueFname} /></Col>
    <Col md={6}>  <TextField id="filled-basic" label="Last Name" variant="filled" className="ContactForm  bg-light" style={{marginBottom:'15px'}} onChange={getValueLname} /></Col>

  </Row>

  <TextField id="filled-basic" label="E-mail1" variant="filled" id="fullWidth" style={{marginBottom:'15px'}}  className="ContactForm"  />
  <TextareaAutosize aria-label="minimum height" minRows={5} placeholder="Please Write a Your Message" className="ContactForm"/>
<Button   type="submit"  className="bg-light">Contained</Button>
<ToastContainer position="top-center" />
</form>
  </Col>
</Row>
     </Container>
      </div>

      <Container fluid >
        
      <Row  style={{backgroundColor:"#1f1d1b"}} >
        <span>.</span>
          <Col md={12} lassName="map" >
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14474.537866531682!2d67.0280672!3d24.9104471!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6e383e3adce474a4!2sAptech%20Computer%20Education%20Site%20Center!5e0!3m2!1sen!2s!4v1633778844041!5m2!1sen!2s" width="100%" height="350"></iframe>
          </Col>
          </Row>
        </Container>   
        <footer className="Footer1">
       <Container >
 <Row className="Footer">
   <Col md={3} ><Image src="https://ishfaqmovers.com/wp-content/uploads/2018/10/mo-white.png"  ></Image>
<h6 className="HomeFooterText">ISHFAQ MOVERS has been one of the leading packers &
   Movers in Karachi-Pakistan for more than 10 years. We deliver a broad range of targeted national and 
   international moving services for home, 
  house, villa, apartments, offices as well as relocation solutions for every purpose.</h6>
   </Col>
   <Col md={{span:4, offset: 2}}  className="mt-3">
     <h3>QUICK LINKS</h3>

     <p><FooterLinks/></p>

     {/* <Route path="/about"><FooterLinks/></Route>
     <Route path="/contact"><FooterLinks/></Route> */}
   </Col>
   
   <Col md={3}  className="mt-2">
   <h3>NEWSLETTER SIGNUP</h3>
  <h6>No spam, unsubscribe at any time.</h6>
   <TextField id="standard-basic" label="Email" type="mail"  /><br/>
   <Button onClick={()=>NewsLetters()} className="HomeButton mt-2 ">Subscribe</Button>
   <br/>
   <h5   className="mt-2">Contact On Social Media</h5>
   <a href="#"><FacebookIcon></FacebookIcon></a>
   <a href="#"><TwitterIcon></TwitterIcon></a>
   <a href="#"><InstagramIcon></InstagramIcon></a>
 
   </Col>
 </Row>
       </Container>
       <hr/>

       </footer>
      </>
    )
  }
  
  export default Contact;